/**
 * @packageDocumentation
 * @module f1/abstract-data-type
 */

import is_exists from '../is/is_exists';
import { t_rec_arr, t_rec, t_arr } from '../types';
import filter from './filter';

export interface Compact {
  <V>(adt: t_rec<string, V | undefined>): t_rec<string, V>;
  <V>(adt: t_arr<V | undefined>): t_arr<V>;

  /**
   * @public
   * @function f1.compact
   * @param adt the array or record we will compact
   * @example
   *
   * ```ts
   * f1.compact([1, 2, null]) === [1, 2]
   * f1.compact({ a: 1, b: undefined }) === { a: 1 }
   * ```
   *
   */
  <V>(adt: t_rec_arr<V | undefined>): t_rec_arr<V>;
}

/**
 * @see Compact
 */
function compact<V>(adt: t_rec<string, V | undefined>): t_rec<string, V>;
function compact<V>(adt: t_arr<V | undefined>): t_arr<V>;
function compact<V>(adt: t_rec_arr<V | undefined>): t_rec_arr<V> {
  return filter<V>(is_exists, adt as t_rec_arr<V>);
}

export default compact;
